import React from "react";

export default function HealthcareBusiness({ data, extraClass = ""  }) {
    if (!data) return null;
    return (
        <section className={`heathcare-business ${extraClass}`}>
            <div className="container">
                <div className="row align-items-end">
                    <div className="col-md-12 col-lg-7">
                        <div className="business-heading">
                            {data?.title && (<h3 className="heading" dangerouslySetInnerHTML={{ __html: data.title }} />)}
                        </div>
                    </div>
                    <div className="col-md-12 col-lg-5">
                        {data?.description && (<div className="business-content">  <p>{data.description}</p>  </div>)}
                    </div>
                </div>
                {data?.testimonials?.length > 0 && (
                    <div className="testimonial-box">
                        <div className="row">
                            {data.testimonials.map((item, index) => (
                                <div className="col-12 col-sm-12 col-md-12 col-lg-4" key={index}>
                                    <div className="star">
                                        {Array.from({ length: item.rating || 5 }).map(
                                            (_, i) => (
                                                <img key={i} src={item.starIcon || "/assets/images/star-icon1.webp"} alt="Star" className="img-responsive" width="28" height="28" loading="lazy" decoding="async" />)
                                        )}
                                    </div>
                                    {item?.text && (
                                        <p className="testimonial-text"> {item.text}  </p>)}
                                    {item?.client && (<div className="client-name">   {item.client} </div>)}
                                </div>
                            ))}
                        </div>
                    </div>
                    
                )}
            </div>
        </section>
    );
}
